import { API } from "../../apiEndPoints/website/apiEndPoints";
import createAxiosInstance, {
  axiosDelete,
  axiosGet2,
  axiosPost2,
} from "../../axios/axiosMiddleware2";
import { store } from "../../redux/store";
const axiosInstance = createAxiosInstance(store);
export const creatReelService = (data: any) => {
  return axiosPost2(axiosInstance, `${API?.OTHER?.CREATE_REEL}`, data);
};
export const fetchReelFeedService = (params: any) => {
  return axiosGet2(axiosInstance, `${API?.OTHER?.REEL_FEED}${params}`);
};
export const likeReelService = (id: number, data: object) => {
  return axiosPost2(axiosInstance, `${API?.OTHER?.likeReel}/${id}/likes`, data);
};
export const commentReelService = (id: number, data: object) => {
  return axiosPost2(
    axiosInstance,
    `${API?.OTHER?.likeReel}/${id}/comments`,
    data
  );
};
export const shareReelService = (id: number) => {
  return axiosGet2(axiosInstance, `${API?.OTHER?.REEL_FEED}/${id}/share`);
};

export const reportReelService = (data: object, id: number) => {
  return axiosPost2(axiosInstance, `${API?.OTHER?.REPORT_REEL}/${id}`, data);
};

export const deleteReelService = (id: number) => {
  return axiosDelete(axiosInstance, `${API?.OTHER?.DELETE_FEED}/${id}`, {
    type: 4,
  });
};

export const getReelConfigService = () => {
  return axiosGet2(axiosInstance, `${API?.OTHER?.REEL_CONFIG}`);
};
